import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { Store } from "@ngrx/store";
import { environment } from "src/environments/environment";

import {
  GetFeedbackTemplateField,
  SubmitRsvp,
  getEventDetailsById,
  submitRsvpfeedback,
} from "../../store/event.actions";
import { MatDialog } from "@angular/material/dialog";
import { NotificationThanksComponent } from "src/app/login/notification-thanks/notification-thanks.component";
// import { StarRatingColor } from '../star-rating/star-rating.component';
@Component({
  selector: "app-feedback-submission",
  templateUrl: "./feedback-submission.component.html",
  styleUrls: ["./feedback-submission.component.scss"],
})
export class FeedbackSubmissionComponent implements OnInit {
  // rating: any = 0;
  // starCount: number = 5;
  // starColor: StarRatingColor = StarRatingColor.accent;
  // starColorP: StarRatingColor = StarRatingColor.primary;
  // starColorW: StarRatingColor = StarRatingColor.warn;

  eventRegForm: FormGroup;
  stopper$: Subject<any> = new Subject();
  isShowForm: boolean = false;
  EventById: any;
  eventId: any;
  userProfileImage: any;
  data: any;
  getFeedbackTemplateFields: any;
  rsvpId: any;
  constructor(
    private fb: FormBuilder,
    private activatedRoute: ActivatedRoute,
    private store: Store<any>,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.activatedRoute.params
      .pipe(takeUntil(this.stopper$))
      .subscribe((params) => {
        console.log(params);
        if (params.id && params.rsvpid) {
          console.log(params);
          this.eventId = params.id;
          this.rsvpId = params.rsvpid;
        }
      });
    this.store.dispatch(new getEventDetailsById(this.eventId));

  }

  ngOnInit() {
    setTimeout(() => {
      this.store
        .select((state) => state.eventManagement.getEventById)
        .subscribe((getEventById: any) => {
          console.log(Object.keys(getEventById).length);
          this.EventById = [];
          if (Object.keys(getEventById).length > 0) {
            this.EventById = getEventById;
            if (this.EventById.profilePic != null) {
              this.userProfileImage = `${environment.host}/event/getImage/${this.eventId}`;
            } else {
              this.userProfileImage = null;
            }
            if((getEventById.eventStatus == 6 && getEventById.is_active == true) || getEventById.is_active == false){
              this.isShowForm = false;    
            }else{
              this.store.dispatch(new GetFeedbackTemplateField(this.eventId));
              this.store
              .select((state) => state.eventManagement.getFeedbackTemplateFields)
              .subscribe((getFeedbackTemplateFields: Array<any>) => {
                if (getFeedbackTemplateFields.length > 0) {
                  this.getFeedbackTemplateFields = getFeedbackTemplateFields;
                  this.showForm(getFeedbackTemplateFields);
                }
              });
            }


          }
        });

    }, 100);
  }

  showForm(data) {
    var obj = {};
    data.forEach((element) => {
      console.log(element);
      if (element.required) {
        obj[element.fieldName] = ["", [Validators.required]];
      } else if (element.fieldType == "five_star_rating") {
        obj[element.fieldName] = ["done"];
      } else {
        obj[element.fieldName] = [""];
      }
    });
    this.eventRegForm = this.fb.group(obj);
    this.isShowForm = true;
  }

  submitRegister() {
    // console.log('kk',this.eventRegForm.value)
    if (this.eventRegForm.invalid) {
      return;
    } else {
      var inputObj = {};
      const data = this.eventRegForm.value;
      var inputData = [];
      this.getFeedbackTemplateFields.forEach((element) => {
        inputData = [
          ...inputData,
          {
            fieldId: element._id,
            fieldName: element.fieldName,
            fieldType: element.fieldType,
            fieldValue: data[element.fieldName],
          },
        ];
      });
      inputObj["formData"] = inputData;
      inputObj["rsvpId"] = this.rsvpId;
      inputObj["eventId"] = this.eventId;
      console.log(inputObj);
      this.store.dispatch(new submitRsvpfeedback(inputObj, this.eventId));
      this.store
        .select((state) => state.eventManagement.feedbackSubmissionResponse)
        .subscribe((getEventById: any) => {
          if (Object.keys(getEventById).length > 0) {
            const dialog = this.dialog.open(NotificationThanksComponent, {
              width: "450px",
              hasBackdrop: true,
              panelClass: "cmp-modal",
              data: {
                text: "feeedbackthanks",
              },
            });
            dialog.afterClosed().subscribe((response) => {
              console.log(response);
              if (response != undefined) {
                if (response == "yes") {
                  window.close();
                }
              }
            });
          }
        });
    }
  }

  close(){
    window.close();
  }

  getsort(arr) {
    return (arr = arr.sort((a, b) => a.sequence - b.sequence));
  }

  getLebel(arr) {
    var findIndex = arr.findIndex((res) => res.fieldType == "textview");
    return arr[findIndex].fieldLabel;
  }

  get getControl() {
    return this.eventRegForm.controls;
  }

  tConvert(time) {
    if (time != undefined) {
      // Check correct time format and split into components
      time = time
        .toString()
        .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];
      // console.log(time)

      if (time.length > 1) {
        // If time format correct
        time = time.slice(1); // Remove full string match value
        time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
        time[0] = +time[0] % 12 || 12; // Adjust hours
      }
      return time.join(""); // return adjusted time or original string
    }
  }

  // onRatingChanged(rating,val) {
  //   console.log(rating,val)
  //   this.rating = rating;
  //   // this.eventRegForm.patchValue({
  //   //   'feedback':rating
  //   // })
  // }
}
